import { call, put, takeLatest } from "redux-saga/effects";
import { RESET_PASSWORD_REQUEST_REQUEST } from "../../actionTypes/resetPasswordRequest";
import {
  resetPasswordRequestSuccess,
  resetPasswordRequestFailure,
} from "../../action/resetPasswordRequest";
import { resetPasswordRequest as resetPasswordRequestAPI } from "../../../api/services/resetPasswordRequest.service";
import { BaseResponse } from "../../response";
import { API_CODES } from "../../../constants";

interface ResetPasswordRequestParams {
  email: string;
  password: string;
  confirmPassword: string;
}

interface ResetPasswordRequestAction {
  type: typeof RESET_PASSWORD_REQUEST_REQUEST;
  payload: ResetPasswordRequestParams;
}

export function* resetPasswordRequestWorker(
  action: ResetPasswordRequestAction
): Generator<unknown, void, BaseResponse> {
  try {
    const response = yield call(resetPasswordRequestAPI, action.payload);
    const info = response.statusinfo.message;

    if (response.status === API_CODES.SUCCESS_CODE || response.status === "SUCCESS") {
      yield put(resetPasswordRequestSuccess(info));
    } else {
      yield put(resetPasswordRequestFailure(info));
    }
  } catch {
    yield put(resetPasswordRequestFailure("Something went wrong"));
  }
}

export function* resetPasswordRequestSaga(): Generator {
  yield takeLatest(RESET_PASSWORD_REQUEST_REQUEST, resetPasswordRequestWorker);
}
